import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import type { TypographyProps } from '@coursera/cds-core';

import { MetadataTypography } from 'bundles/program-loggedin-shared/components/Metadata';

import _t from 'i18n!nls/program-loggedin-shared';

const CreditCount: React.VFC<{ credits: number; color?: TypographyProps['color'] }> = ({ credits, color }) => (
  <MetadataTypography inline color={color}>
    <FormattedMessage
      message={_t('{creditValue} {creditValue, plural, =1 { credit} other { credits}}')}
      creditValue={credits}
    />
  </MetadataTypography>
);

export default CreditCount;
